import userInfoDomain from '@common/domain/user';
import { TUser } from '@common/domain/user/types';

const { fetchUserInfo, getAllInfo, updateOneItem } = userInfoDomain();

// 将用户信息拉取并填充至表内
export const fillUserInfo = fetchUserInfo;

export const getAllUserInfo = (): TUser => getAllInfo();

// 更新某一参数
export const updateSomeone = <T extends keyof TUser>(key: T, value: TUser[T]) =>
  updateOneItem(key, value);
